

















































































import Vue from 'vue'
import { User } from 'firebase';
export default Vue.extend({
  props: {
    client_id: {
      type: String
    },
    redirect_uri: {
      type: String
    },
    response_type: {
      type: String
    },
    scope: {
      type: String
    },
    state: {
      type: String
    }
  },

  data() {
    return {
      alerts: [] as {text:string, type:string, code:string}[],
      application: {} as {[key:string]: any},
      codes: [] as {_id: string, [key:string]: any}[],
      loading: true,
      request: {
        clientId: undefined as string | undefined,
        redirectUri: undefined as string | undefined,
        responseType: undefined as string | undefined,
        scope: undefined as string | undefined,
        state: undefined as string | undefined
      },
      scopes: {
        user: [] as string[],
        selected: [] as string[],
        excluded: [] as string[]
      },
      unregister: () => {}
    }
  },
  computed: {
    authUser():User | null {
      return this.$auth.currentUser
    },
    userId():string { return this.$store.state.auth.user.uid }
  },
  methods: {
    async approve() {
      try {
        const request = {...this.request}
        request.scope = this.scopes.selected.filter(scope => this.scopes.user.indexOf(scope) > -1).join(" ")
        const code = await this.$oauth.getAuthCode(request)
        if (this.request.redirectUri) {
          window.location.href = `${this.request.redirectUri}?code=${code}&state=${this.request.state}`
        } else {
          this.alerts.push({
            text: `Authorization code granted: ${code}`,
            type: "success",
            code: "code-granted"
          })
          this.alerts = this.alerts.filter(alert => alert.code !== "excluded-scope")
        }
      } catch (err) {
        this.$error.alert(err)
      }
    },
    deny() {
      window.location.href = `${this.request.redirectUri}?error=access_denied`
    },
    async deleteCode(id) {
      await this.$db.collection("applications").doc(this.application._id)
        .collection("codes").doc(id).delete()
      this.alerts = this.alerts.filter(alert => alert.text.indexOf(id) == -1)
    },
    getCodes(id) {
      this.unregister()
      this.unregister = this.$db.collection("applications").doc(id).collection("codes").where("userId", "==", this.userId).onSnapshot(codeDocs => {
        if (codeDocs.size) {
          this.codes = codeDocs.docs.map(doc => {return {_id: doc.id, ...doc.data()} })
        } else {
          this.codes = []
        }
      })
    },
    async init() {
      const query = this.$route.query
      const { client_id, redirect_uri, response_type, scope, state } = query

      const clientId = typeof client_id == "string" ? client_id : undefined
      const redirectUri = typeof redirect_uri == "string" ? redirect_uri : undefined
      const responseType = typeof response_type == "string" ? response_type : undefined
      const _scope = typeof scope == "string" ? decodeURI(scope) : undefined
      const _state = typeof state == "string" ? state : undefined

      if (clientId) {
        try {
          this.application = await this.$oauth.getClient(clientId)
          this.getCodes(clientId)
        } catch (err) {
          window.console.log(err)
          if (err.message) alert(err.message)
        }

        this.request = {
          clientId,
          redirectUri,
          responseType,
          scope: _scope,
          state: _state
        }

        this.$set(this.scopes, "user", this.$store.state.auth.token.claims.permissions)
        this.$set(this.scopes, "selected", _scope ? _scope.split(" ") : [] as string[])
        this.scopesDiff()

      } else {
        const message = "Invalid clientId specified. Unable to get application data."
        alert(message)
      }
      this.loading = false
    },
    scopesDiff() {
      const user = this.scopes.user
      const selected = this.scopes.selected
      const scopes = [] as string[]
      selected.forEach(scope => user.indexOf(scope) === -1 ? scopes.push(scope) : null)
      if (scopes.length) {
        this.alerts.push({
          text: "Application is requesting permissions that you do not have as a user.", 
          type: "warning",
          code: "excluded-scope"
        })
        this.$set(this.scopes, "excluded", scopes)
      }
    }
  },
  mounted() {
    this.$auth.onAuthStateChanged(user => {
      if (user) {
        this.init()
      }
    })
  },
  beforeDestroy() {
    this.unregister()
  }
})
